import Tooltip from '@mui/material/Tooltip';
import { useAcademicNamespace, usePermissions } from '@tyro/api';
import { toast } from '@tyro/core';
import { useTranslation } from '@tyro/i18n';
import { AlarmIcon } from '@tyro/icons';
import { getPrintFireDrill } from '@tyro/printing';
import { IconButtonAnimate } from '../../icon-button-animate';

export function PrintEmergencyListButton() {
  const { t } = useTranslation(['common']);
  const { isStaffUserWithPermission } = usePermissions();
  const { defaultActiveAcademicNamespace } = useAcademicNamespace();

  const printEmergencyClassList = () => {
    toast.promise(
      async () => {
        const { print_fireDrill } = await getPrintFireDrill(
          defaultActiveAcademicNamespace?.academicNamespaceId,
        );
        if (print_fireDrill.url) {
          window.open(print_fireDrill.url, '_blank', 'noreferrer');
        } else {
          throw new Error('Print failed');
        }
      },
      {
        loading: t('common:loading'),
        error: t('common:snackbarMessages.errorFailed'),
      },
    );
  };

  if (
    !isStaffUserWithPermission('ps:1:printing_and_exporting:fire_drill_print')
  ) {
    return null;
  }

  return (
    <Tooltip title={t('common:printEmergencyClassList')}>
      <IconButtonAnimate
        color="default"
        onClick={printEmergencyClassList}
        sx={{ width: 40, height: 40 }}
      >
        <AlarmIcon />
      </IconButtonAnimate>
    </Tooltip>
  );
}
